export const BED_CONFIGS = {
  'Twin/Twin': {
    materials: 342,
    fabLabor: 440,
    paint: 500,
    total: 1282,
    price: 5100,
  },
  'Twin/Full': {
    materials: 390,
    fabLabor: 500,
    paint: 525,
    total: 1415,
    price: 5800,
  },
  'Full/Full': {
    materials: 435,
    fabLabor: 550,
    paint: 550,
    total: 1535,
    price: 6400,
  },
  'Twin XL/Queen': {
    materials: 460,
    fabLabor: 550,
    paint: 575,
    total: 1585,
    price: 6800,
  },
  'Queen/Queen': {
    materials: 520,
    fabLabor: 600,
    paint: 600,
    total: 1720,
    price: 7600,
  },
  'Triple': {
    materials: 630,
    fabLabor: 750,
    paint: 700,
    total: 2080,
    price: 8800,
  },
  'Quad': {
    materials: 850,
    fabLabor: 1000,
    paint: 850,
    total: 2700,
    price: 11600,
  },
};

export const LABOR_RATES = {
  ripCut: 10,
  crossCut: 5,
  edgeBanding: 1, // per linear foot
  countersunkHole: 0.15,
  pocketHole: 0.25,
};

export const WOOD_TYPES = {
  'Select Pine': 2.00,
  'Poplar': 3.50,
  'Maple': 4.00,
  'White Oak': 5.00,
};

export const PLYWOOD_COSTS = {
  '11/16" Birch': 40,
  '11/16" Maple UV': 120,
  '1/2" Birch': 27,
  '1/2" Maple UV': 80,
  '1/4" Birch': 19,
  '1/4" Maple UV': 50,
};

export const FINISHES = [
  'Painted White',
  'Painted Gray',
  'Painted Black',
  'Custom Color',
  'Natural Clear',
  'Stained',
];

export const GUARDRAIL_CONFIGS = [
  'L-Shape',
  'U-Shape',
  'Full Wrap',
  'None',
];

export const ENTRY_TYPES = [
  'Ladder',
  'Staircase',
];

export const CORNER_POSTS_OPTIONS = [0, 1, 2, 4];

export const ADDONS = [
  'Staircase w/ Storage',
  'Slide',
  'Trundle',
  'Desk',
  'Storage Drawers',
  'LED Lights',
];

